import { SiteLayout } from "@/layouts/site-layout";
import { SEO } from "@/components/SEO";
import { MvpCalculatorWidget } from "@/components/calculators/mvp-calculator-widget";

function Calculator() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "MVP Cost Calculator",
    "description": "Interactive cost calculator to estimate your MVP build cost in days and dollars",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  };

  return (
    <SiteLayout>
      <SEO
        title="MVP Cost Calculator | Estimate Your MVP Build Cost Online"
        description="Calculate cost to build MVP instantly. Use our interactive startup MVP cost calculator online to estimate your MVP build cost in days and dollars. AI-powered MVP cost estimator for founders and agencies."
        keywords="MVP cost calculator, MVP cost estimate, calculate cost to build MVP, startup MVP cost calculator online, interactive cost calculator to estimate your MVP build cost in days and dollars, founder tool: how much does a one-week MVP cost, use our AI-powered MVP cost estimator for agencies"
        canonicalUrl={`${typeof window !== 'undefined' ? window.location.origin : 'https://oneweekmvps.com'}/calculator`}
        structuredData={structuredData}
      />
      <div className="pt-32 pb-20">
        <MvpCalculatorWidget mode="page" />
      </div>
    </SiteLayout>
  );
}

export default Calculator;
